export const escapeTableText = (value) => String(value || '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

export const createDefaultTableMarkup = (firstColumnLabel, secondColumnLabel, tableId) => (
  `<table class="pmpi-rich-table pmpi-created-table" data-pmpi-table="true" data-pmpi-created-table="true" data-pmpi-row-numbers="true" data-header-row="true" data-pmpi-new-table="${tableId}"><thead><tr><th>${escapeTableText(firstColumnLabel)}</th><th>${escapeTableText(secondColumnLabel)}</th></tr></thead><tbody><tr><td><br></td><td><br></td></tr><tr><td><br></td><td><br></td></tr></tbody></table><p><br></p>`
);

export const tabularTextToTableMarkup = (plainText) => {
  const rows = plainText.split(/\r?\n/)
    .filter((row, index, allRows) => row.length > 0 || index < allRows.length - 1);
  if (!rows.length || !rows.some((row) => row.includes('\t'))) return null;

  const body = rows.map((row) => (
    `<tr>${row.split('\t').map((value) => `<td>${escapeTableText(value) || '<br>'}</td>`).join('')}</tr>`
  )).join('');
  return `<table class="pmpi-rich-table" data-pmpi-table="true"><tbody>${body}</tbody></table><p><br></p>`;
};
